import { action, makeAutoObservable } from 'mobx';

import { State } from '~/store/types';

export interface ConfirmationShowProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmLabel?: string;
  dangerous?: boolean;
}

class ConfirmationStore {
  rootStore: State;
  title: string | null = null;
  showModal = false;
  message: string | null = null;
  onConfirm: (() => void) | null = null;
  onCancel?: () => void;
  confirmLabel: string | null = null;
  dangerous = false;
  constructor(rootStore: State) {
    makeAutoObservable(this, {
      show: action.bound,
      cancel: action.bound,
    });
    this.rootStore = rootStore;
  }

  show({ title, message, onConfirm, onCancel, confirmLabel, dangerous }: ConfirmationShowProps) {
    this.title = title;
    this.message = message;
    this.onCancel = onCancel;
    this.onConfirm = onConfirm;
    this.confirmLabel = confirmLabel ?? null;
    this.dangerous = dangerous ?? false;
    this.showModal = true;
  }
  confirm = () => {
    if (this.onConfirm) {
      this.onConfirm();
    }
    this.clear();
  };

  cancel = () => {
    if (this.onCancel) {
      this.onCancel();
    }
    this.clear();
  };

  private clear() {
    this.onConfirm = null;
    this.onCancel = undefined;
    this.title = null;
    this.message = null;
    this.confirmLabel = null;
    this.dangerous = false;
    this.showModal = false;
  }
}

export default ConfirmationStore;
